export const createBreadcrumbStucturedData = (
  items: { name: string; link: string }[]
) => {
  const itemListElement = items.map(({ name, link }, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name,
    item: link,
  }))

  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement,
  }
}
